/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorageDetails
 */
export interface StorageDetails {
    /**
     * 
     * @type {number}
     * @memberof StorageDetails
     */
    storageUsed: number;
    /**
     * 
     * @type {number}
     * @memberof StorageDetails
     */
    storageLeft?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageDetails
     */
    totalAvailableStorage?: number;
}

/**
 * Check if a given object implements the StorageDetails interface.
 */
export function instanceOfStorageDetails(value: object): value is StorageDetails {
    if (!('storageUsed' in value) || value['storageUsed'] === undefined) return false;
    return true;
}

export function StorageDetailsFromJSON(json: any): StorageDetails {
    return StorageDetailsFromJSONTyped(json, false);
}

export function StorageDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'storageUsed': json['storageUsed'],
        'storageLeft': json['storageLeft'] == null ? undefined : json['storageLeft'],
        'totalAvailableStorage': json['totalAvailableStorage'] == null ? undefined : json['totalAvailableStorage'],
    };
}

export function StorageDetailsToJSON(json: any): StorageDetails {
    return StorageDetailsToJSONTyped(json, false);
}

export function StorageDetailsToJSONTyped(value?: StorageDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'storageUsed': value['storageUsed'],
        'storageLeft': value['storageLeft'],
        'totalAvailableStorage': value['totalAvailableStorage'],
    };
}

